<div
  #layoutRoot
  class="frame-grid-layout"
  [style.gridTemplateColumns]="gridTemplateColumns"
  [style.gridAutoRows.px]="gridAutoRowsPx"
  [style.gap.px]="gapPx"
>
  <div
    *ngFor="let entry of layoutItems; trackBy: trackLayoutItem"
    class="frame-grid-layout__item"
    [style.gridColumn]="entry.gridColumn"
    [style.gridRow]="entry.gridRow"
  >
    <ng-container
      *ngTemplateOutlet="resolvedTemplate; context: { $implicit: entry.item, item: entry.item, index: entry.index, key: entry.key }"
    ></ng-container>
  </div>
</div>

<div #appendSentinel class="frame-grid-layout__append-sentinel" aria-hidden="true"></div>
